import React, { Component } from 'react';
//import {connect} from 'react-redux';

import './../../../scss/App.scss';
import * as Utils from '../../../js/utils/utils';
import FormContainer from '../form/FormContainer';

import { trackingWrapper } from '../../utils/analytics';

class Login extends Component {

	constructor(props){
		super(props);

		this.state = {
			"firstName": this.props.firstName,
			"displayName": this.props.displayName,
			"displayNameBadWord": false,
			firstNameBadWord: false,
			"email": this.props.email,
			"agreeEmail": this.props.agreeEmail,
			"processing": false
		}

	}

	componentDidMount(){
		//this.animateIn();

		//window.sounds.introBg.play();

		/*
		let _this = this;

		setTimeout(() => {
			_this.props.handleIntroComplete();
		}, 3000);
		*/

	}

	animateIn(){
		/*
		window.TweenMax.set(this.refs.logo, {transform:"translateX(-10%)", opacity:0});
		window.TweenMax.to(this.refs.logo, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.tagline, {transform:"translateX(-90%)", opacity:0});
		window.TweenMax.to(this.refs.tagline, 2.2, {ease:"expo.out", transform:"translateX(-50%)", opacity:1});

		window.TweenMax.set(this.refs.crosswordBg, {opacity:0});
		window.TweenMax.to(this.refs.crosswordBg, 2, {ease:"linear", opacity:1});
		window.TweenMax.to(this.refs.crosswordBg, 20, {top:"-16vw"});

		let _this = this;
		setTimeout(() => {
			_this.aniamteOut();
			_this.props.handleIntroInComplete()
		}, 4000);
		*/
	}

	aniamteOut(){
		/*
		let _this = this;

		window.TweenMax.to(this.refs.crosswordBg, .2, {opacity:0});
		window.TweenMax.to(this.refs.host, .2, {opacity:0});
		window.TweenMax.to(this.refs.tuneIn, .3, {opacity:0});
		window.TweenMax.to(this.refs.bg, 1, {opacity:0, onComplete:function(){
			_this.props.handleIntroOutComplete();
		}});

		window.TweenMax.to(this.refs.logo, .4, {opacity:0});
		window.TweenMax.to(this.refs.logo, .5, {ease:"expo.in", transform:"translateX(-150%)"});

		window.TweenMax.to(this.refs.tagline, .4, {opacity:0});
		window.TweenMax.to(this.refs.tagline, .5, {ease:"expo.in", transform:"translateX(50%)"});
		*/
	}

	handleSignUp(){
		const firstName = this.refs.firstName.value;
		const displayName = this.refs.displayName.value;
		const email = this.refs.email.value;

		let errorMsg = "";

		if(firstName === ""){
			errorMsg += "\nPlease enter your First Name.";
		}

		if(!Utils.isEmail(email)){
			errorMsg += "\nPlease enter a valid Email Address.";
		}

		if(errorMsg !== ""){
			alert(errorMsg);
		}
		else {
			if(window.app.configData.useAPI_badWords_register){

				this.setState({
					"processing": true
				});

				const apiSource = window.app.configData.APIsource;
				const badwordAPI = window.app.configData[apiSource].badwordFilter;

				let data = [
					{
						"key": 0,
						"value": displayName
					},
					{
						key: 1,
						value: firstName
					}
				]

				fetch(badwordAPI, {
					method: 'POST',
					body: JSON.stringify({
						"type": "json",
						"data": data
					}),
				})
				.then((response) => response.json())
				.then((data) => {
					console.log('badword api Success:', data);

					// if bad words found, show error
					if(data.badWords.length > 0){
						
						this.setState({
							"processing": false,
							"displayNameBadWord": data.badWords.some(val=>val===0),
							firstNameBadWord: data.badWords.some(val=>val===1)
						});
						
						alert("Inappropriate language was found. Please try other words.");
					}
					else {
						// tracking
						trackingWrapper('event', 'ASDIY-game-start', {'event_category':'america-says-diy'});

						this.submitRegistration();
					}
				})
				.catch((error) => {
					
					console.error('badword api Error:', error);
					alert("Something went wrong. Please try again later.");

					this.setState({
						"processing": false
					});
					
				});
			}
			else {
				this.submitRegistration();
			}
		}
		
		/*
		console.log("firstName", firstName);
		console.log("displayName", displayName);
		console.log("email", email);
		*/
	}

	submitRegistration(){
		const firstName = this.refs.firstName.value;
		const displayName = this.refs.displayName.value;
		const email = this.refs.email.value;
		const agreeEmail = this.refs.agreeEmail.checked;

		if(window.app.configData.useAPI_register){
			const apiSource = window.app.configData.APIsource;
			const registrationAPI = window.app.configData[apiSource].registration;

			let data = {
				"firstName": firstName,
				"email": email,
				"agreeEmail": agreeEmail,
				"type": 'asdiy'
			}

			this.setState({
				"processing": true
			});

			fetch(registrationAPI, {
				method: 'POST',
				body: JSON.stringify(data),
			})
			.then((response) => response.json())
			.then((data) => {
				console.log('register api Success:', data);
				
				if(data.status === 201){
					this.setState({
						"processing": false
					});

					this.props.handleSignUp(firstName, displayName, email, agreeEmail);
				}
				else if(data.status === 429){
					this.props.handleSignUp(firstName, displayName, email, agreeEmail);
				}
			})
			.catch((error) => {
				this.setState({
					"processing": false
				});

				console.error('register api Error:', error);
				alert("Something went wrong. Please try again later.");
			});
		}
		else {
			this.props.handleSignUp(firstName, displayName, email);
		}
	}

	handleOnChange(ref){
		if(ref === "agreeEmail"){
			this.setState({
				"agreeEmail": this.refs[ref].checked
			})
		}
		else {
			this.setState({ 
				[`${ref}`]: this.refs[ref].value 
			})
		}
	}

	renderSubmitBtn(){
		let processing = "";

		if(this.state.processing){
			processing = "processing";
		}

		return(
			<div className={"submitBtn " + processing} onClick={() => this.handleSignUp()}>
				<div className="label">Submit</div>
				<div className="spinner fas fa-spinner fa-pulse"></div>
			</div>
		);
	}

	render() {
		let badWordError = "", firstNameBadWordError = "";

		if(this.state.displayNameBadWord){
			badWordError = "error"
		}

		if (this.state.firstNameBadWord) {
			firstNameBadWordError = "error";
		}

		return (
			<div id="login-panel">
				<div className="heading">Create Your Own America Says Game</div>
				<form name="login-form">
					<input type="text" className={firstNameBadWordError} maxLength="20" placeholder="First Name" name="firstName" ref="firstName" value={this.state.firstName} onChange={() => this.handleOnChange("firstName")} />
					<input type="text" className={badWordError} maxLength="20" placeholder="Displayed Name (optional)" name="displayName" ref="displayName" value={this.state.displayName} onChange={() => this.handleOnChange("displayName")} />
					<input type="text" placeholder="Email Address" name="email" ref="email" value={this.state.email} onChange={() => this.handleOnChange("email")} />
					<div className="legal">
						<input type="checkbox" className="agreeEmail" ref="agreeEmail" checked={this.state.agreeEmail} onChange={() => this.handleOnChange("agreeEmail")} />
						By clicking "Submit" you are opting into the newsletter, and you agree to our Privacy Policy</div>
					{this.renderSubmitBtn()}
				</form>
			</div>
		);
	}
}

export default Login;


// WEBPACK FOOTER //
// ./src/js/components/generator/Login.js